import React, { useEffect, useState } from "react";
import { VolumeX, BadgeCheck, Loader2 } from "lucide-react";
import Modal from "@/components/chat/Modal";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { getInitials, avatarColor } from "@/lib/avatar";
import { toast } from "sonner";

export default function MutedDialog({ onClose }) {
  const { t } = useI18n();
  const [list, setList] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/social/muted"); setList(data); }
    catch { setList([]); }
  };
  useEffect(() => { load(); }, []);

  const unmute = async (id) => {
    try {
      await api.post("/social/unmute", { author_id: id });
      setList((l) => l.filter((u) => u.id !== id));
      toast(t("unmuted_toast"));
    } catch { toast.error(t("s_could_not_delete") || "Failed"); }
  };

  return (
    <Modal title={t("muted_accounts")} onClose={onClose}>
      <div data-testid="muted-dialog">
        {list === null ? (
          <div className="py-16 grid place-items-center text-[var(--rc-muted)]"><Loader2 className="animate-spin" /></div>
        ) : list.length === 0 ? (
          <div className="py-16 text-center">
            <div className="h-16 w-16 mx-auto rounded-full grid place-items-center bg-[var(--rc-surface)] text-[var(--rc-muted)] mb-3"><VolumeX size={26} /></div>
            <p className="text-[var(--rc-muted)]" data-testid="no-muted-msg">{t("no_muted")}</p>
          </div>
        ) : (
          <div className="divide-y divide-[var(--rc-border)]">
            {list.map((u) => (
              <div key={u.id} className="flex items-center gap-3 py-3" data-testid={`muted-item-${u.id}`}>
                <div className="h-11 w-11 rounded-full grid place-items-center text-[var(--rc-gold)] text-sm font-semibold overflow-hidden shrink-0 border-2 border-[var(--rc-gold)]" style={{ backgroundColor: avatarColor(u.name) }}>
                  {u.avatar ? <img src={u.avatar} alt="" className="h-full w-full object-cover" /> : getInitials(u.name)}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="truncate">{u.name}</div>
                  {u.username && <div className="text-xs text-[var(--rc-muted)] truncate">@{u.username}</div>}
                </div>
                <button onClick={() => unmute(u.id)} data-testid={`unmute-${u.id}`}
                  className="shrink-0 rounded-full border border-[var(--rc-gold)]/50 text-[var(--rc-gold)] text-sm font-medium px-4 py-1.5">
                  {t("unmute")}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
